module.exports = __webpack_public_path__ + "img/mango.0156e3cf.svg";